import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import AboutUs from './components/pages/AboutUs';
import SignUp from './components/pages/SignUp';
import Products from './components/pages/Products';
import Industries from './components/pages/Industries';
import Renewable from './components/pages/Renewable';
import Railway from './components/pages/Railway';
import Mining from './components/pages/Mining';
import Petrochemical from './components/pages/Petrochemical';
import Automotive from './components/pages/Automotive';
import Telecommunication from './components/pages/Telecommunication';
import ContactUs from './components/pages/ContactUs';


function App() {
    return (
        <>
        <Router>
            <Navbar />
                <Switch>
                    <Route path='/' exact component={Home} />
                    <Route path='/about-us'  component={AboutUs} />
                    <Route path='/products'  component={Products} />
                    <Route path='/industries'  component={Industries} />
                    <Route path='/renewable-energy'  component={Renewable} />
                    <Route path='/railway'  component={Railway} />
                    <Route path='/petrochemical'  component={Petrochemical} />
                    <Route path='/mining'  component={Mining} />
                    <Route path='/telecommunication'  component={Telecommunication} />
                    <Route path='/contact-us'  component={ContactUs} />
                    <Route path='/automotive'  component={Automotive} />
                    <Route path='/sign-up'  component={SignUp} />
                </Switch>
        </Router>

        </>

    );

}

export default App;